import { useEffect, useState } from "react";
import { useStore } from "../../helpers/store_context";

var POLL_INTERVAL = 5 * 60 * 1000; // 5 minutes

function VersionBanner() {
  var store = useStore();
  var [updateAvailable, setUpdateAvailable] = useState(false);

  useEffect(function () {
    // Derive the running app's entry filename from the DOM rather than
    // a network fetch. This avoids a race condition: if a deploy finishes
    // between when the browser loaded index.html and when this component
    // mounts, a network-fetched baseline would reflect the new build while
    // the running code is old — the banner would never fire.
    var currentEntryFile = null;
    var script = document.querySelector(
      'script[type="module"][src^="/vite-assets/"]',
    );
    if (script) {
      // Strip leading "/" so the value matches the manifest's "file" field
      // (manifest: "vite-assets/index-abc.js", DOM: "/vite-assets/index-abc.js")
      currentEntryFile = script.getAttribute("src").replace(/^\//, "");
    }

    var intervalId = setInterval(function () {
      if (!currentEntryFile) {
        return;
      }

      fetch("/.vite/manifest.json")
        .then(function (response) {
          if (!response.ok) {
            throw new Error("Failed to fetch manifest");
          }
          return response.json();
        })
        .then(function (manifest) {
          var keys = Object.keys(manifest);
          for (var i = 0; i < keys.length; i++) {
            var entry = manifest[keys[i]];
            if (entry.isEntry && entry.file !== currentEntryFile) {
              setUpdateAvailable(true);
              clearInterval(intervalId);
              return;
            }
          }
        })
        .catch(function () {
          // A failed fetch shows nothing and logs nothing (the user might
          // be offline for a moment). The next poll tries again.
        });
    }, POLL_INTERVAL);

    // A manifest that arrives after unmount needs no guard: React
    // ignores the state update, and clearing a cleared interval does
    // nothing.
    return function () {
      clearInterval(intervalId);
    };
  }, []);

  // The idle timer reads the note. When nobody has used the screen for
  // five minutes, it loads the new code (back_to_today.tsx), so a shared
  // screen does not run the old code until someone taps Refresh.
  useEffect(
    function () {
      if (updateAvailable) store.markNewVersionAvailable();
    },
    [store, updateAvailable],
  );

  if (!updateAvailable) {
    return null;
  }

  return (
    <div className="app-banner app-banner--info">
      <span>A new version is available.</span>
      <button
        className="app-banner__button"
        onClick={function () {
          // A reload ends every request on its way, so a cost being
          // saved is sent and answered first, for a few seconds at most
          // (#150). If it was not saved, its message is on screen, and
          // the page stays so the person can read it. The next tap goes
          // on.
          store.finishBillsSaves().then(function (mayReload) {
            if (mayReload) window.location.reload();
          });
        }}
      >
        Refresh
      </button>
    </div>
  );
}

export default VersionBanner;
